import { useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';

const InviteSignUp = () => {
  const { invitationDetails } = useParams();
  const inviteDetails = invitationDetails?.split('|');
  const navigate = useNavigate();

  useEffect(() => {
    navigate('/signupbyinvite', {
      state: {
        email: inviteDetails?.[0],
        organizationID: inviteDetails?.[1],
        language: inviteDetails?.[2],
      },
    });
  }, []);

  return <div>InviteSignUp</div>;
};

export default InviteSignUp;
